import { type EntityOptions, getNestedEntity } from 'models';
import type { ReactNode } from 'react';
import { Slider } from 'ui';
import { EntityCard } from '../entity-card';
import { useFeaturedChannelEntities } from './hooks';

type P = {
  channelId: string;
  controls: {
    seeAll?: { onClick?: () => void };
    title: ReactNode;
  };
  description?: ReactNode;
  emptyState?: ReactNode;
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
};

const ChannelsSlider = ({
  channelId,
  controls: { seeAll, title },
  description,
  emptyState,
  getPathToEntityDetail,
}: P) => {
  const {
    isFeatured,
    query: { data, fetchNextPage, hasNextPage, isFetching, isLoading },
  } = useFeaturedChannelEntities({
    allowUnfeatured: Boolean(seeAll?.onClick),
    channelId,
  });

  const channelEntities = data?.pages.flat();

  return (
    <Slider
      controls={{
        seeAll,
        title,
      }}
      description={description}
      emptyState={emptyState}
      items={channelEntities?.map((entity) => ({
        children: <EntityCard entity={getNestedEntity(entity)} getPathToEntityDetail={getPathToEntityDetail} />,
        key: `entity-${getNestedEntity(entity).data.id}`,
      }))}
      queryData={{
        fetchNextPage,
        hasNextPage: hasNextPage && isFeatured,
        isFetching,
        isLoading,
      }}
    />
  );
};

export default ChannelsSlider;
